<template>
  <section>
    <header>
      <span>Характеристики</span>
      <VLink
        material="add"
        @click="addProductCategoryCharacteristics"
      >
        Добавить
      </VLink>
    </header>

    <div class="content">
      <VDataGridV2
        layout="fill"
        :data="productCategory.characteristics"
      >
        <VDataGridColumnV2
          id="id"
          label="ID"
          width="60px"
        />

        <VDataGridColumnV2
          id="name"
          label="Название"
        />

        <VDataGridColumnV2
          id="type"
          label="Тип"
          width="150px"
        >
          <template #default="{ row }">
            {{ row.valueTypeName }}
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="unit"
          label="Ед. изм"
          width="80px"
        >
          <template #default="{ row }">
            <template v-if="row.unit && row.unit.name">
              {{ row.unit.name === 'строка' ? '' : row.unit.name }}
            </template>
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="required"
          label="Поле обязательно"
          content-align="center"
          width="175px"
        >
          <template #default="{ row }">
            <VSwitch
              theme="slider"
              v-model="row.validations.isRequired"
              @update:modelValue="onCharacteristicRequiredChange($event, row)"
            />
          </template>
        </VDataGridColumnV2>

        <VDataGridColumnV2
          id="action"
          content-align="right"
          width="48px"
        >
          <template #default="{ row }">
            <VButton @click="detachCharacteristic(row)">
              <template #icon>
                <VIcon material="delete"/>
              </template>
            </VButton>
          </template>
        </VDataGridColumnV2>
      </VDataGridV2>
    </div>
  </section>
</template>

<style lang="scss" src="./ProductCategoryCharacteristics.scss"/>

<script lang="ts">

import ProductCategoriesService from '@/domains/ProductCategories/ProductCategoriesService';

export default defineComponent({
	name: 'ProductCategoryCharacteristics',

	props: {
		productCategory: {
			type:    Object,
			default: null,
		},
	},

	emits: ['loadProductCategory'],

	computed: {
		/** Режим создания категории — мутируем сущность напрямую, не дёргая бэк */
		createMode(): boolean {
			return Boolean(!this.productCategory.id);
		},
	},

	methods: {
		/**
		 * Открыть диалог добавления характеристик к категории
		 */
		addProductCategoryCharacteristics(): void {
			ProductCategoriesService.showProductCategoryCharacteristicsDialog(
				this.productCategory,
				this.attachCharacteristic,
				this.detachCharacteristic,
			);
		},

		/**
		 * Привязать характеристику к категории. В режиме создания — мутация
		 * сущности; для существующей категории — RPC и обновление массива.
		 */
		attachCharacteristic(characteristic: any): void {
			if (this.createMode) {
				this.productCategory.attachCharacteristic(characteristic);
				return;
			}

			ProductCategoriesService
				.attachCharacteristic(this.productCategory.id, characteristic.id)
				.then(() => {
					this.productCategory.characteristics.push(characteristic);
				});
		},

		/**
		 * Отвязать характеристику от категории. Симметрично attachCharacteristic.
		 */
		detachCharacteristic(characteristic: any): void {
			if (this.createMode) {
				this.productCategory.detachCharacteristic(characteristic);
				return;
			}

			ProductCategoriesService
				.detachCharacteristic(this.productCategory.id, characteristic.id)
				.then(() => {
					const index = this.productCategory.characteristics.findIndex(
						(item: any) => item.id === characteristic.id,
					);
					if (index >= 0) {
						this.productCategory.characteristics.splice(index, 1);
					}
				});
		},

		/**
		 * Переключение флага «Обязательно» у характеристики. В режиме создания —
		 * локальная мутация, иначе сохраняется через сервис и эмитится перезагрузка.
		 */
		onCharacteristicRequiredChange(value: boolean | null, characteristic: any): void {
			const booleanValue = Boolean(value);

			if (this.createMode) {
				this.productCategory.onCharacteristicRequiredChange(booleanValue, characteristic);
				return;
			}

			if (typeof characteristic.validations.isRequired === 'boolean') {
				ProductCategoriesService.updateIsRequiredCharacteristic(
					this.productCategory.id,
					characteristic.id,
					booleanValue,
				).then(() => {
					characteristic.validations.isRequired = booleanValue;
					this.$emit('loadProductCategory');
				});
			}
		},
	},
});
</script>
